import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface DistributorModalEventEntityParams {
  location: string;
  count: number;
  distributorId: number;
}
export class DistributorModalEventEntity extends BaseEntityClass {
  location: string;
  count: number;
  distributorId: number;
  constructor(params: DistributorModalEventEntityParams) {
    super();
    this.type = "distributor_modal_event";
    this.entity_version = 2;
    this.location = params.location;
    this.count = params.count;
    this.distributorId = params.distributorId;
  }
}
